<template>
  <div class="card mb-25 border-0 radius-7 bg-white stats-item">
    <div class="card-body p-15 p-sm-20 p-md-25 pt-lg-30 letter-spacing">
      <div class="row justify-content-between">
        <div class="col-lg-5 col-md-5 flex-card-custom">
          <div
            class="icon position-relative text-info-light rounded-1 text-center"
          >
            <i class="flaticon-folder-1"></i>
          </div>

          <div class="flex-lg-column ml-10 info d-flex align-items-center">
            <span class="fs-13 d-block text-uppercase text-dark-emphasis fw-bold">
              TAMANHO TOTAL DE UPLOAD
            </span>
            <div class="d-flex align-items-center width-100 mt-2">
              <h4 class="fw-black mb-0 me-10 lh-1">{{ (getMetricsToday.total_size / (1024 * 1024)).toFixed(2) + " MB" }}</h4>
            </div>
          </div>

        </div>
        
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapGetters } from 'vuex';

export default defineComponent({
  name: "UploadTotalSize",

  data: function () {
    return {
      hold: [
        {
          name: "On Hold Tickets",
          data: [7, 8, 9, 9, 8, 9, 8, 9, 11, 9, 8],
        },
      ],
      onHoldTicketsChart: {
        chart: {
          type: "area",
          toolbar: {
            show: false,
          },
        },
        colors: ["#20C7D9"],
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          labels: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          tooltip: {
            enabled: false,
          },
        },
        yaxis: {
          show: false,
        },
        grid: {
          show: false,
          strokeDashArray: 5,
          borderColor: "#dfe7f1",
        },
        tooltip: {
          enabled: false,
          style: {
            fontSize: "14px",
            fontFamily: "Red Hat Display, sans-serif",
          },
        },
      },
    };
  },
  computed:{
    ...mapGetters([
      'getMetricsToday'
    ])
  },
});
</script>
